import { AnimatePresence, motion } from "framer-motion";
import { ToastWrapper } from "./SuccessToastStyles";

interface SuccessToastProps {
  message: string;
}

const SuccessToast = ({ message }: SuccessToastProps) => {
  return (
    <AnimatePresence>
      {message && (
        <ToastWrapper
          as={motion.div}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
        >
          {message}
        </ToastWrapper>
      )}
    </AnimatePresence>
  );
};

export default SuccessToast;
